import React, { useState, useEffect } from 'react';

const InfoTooltipIcon = ({ tooltipText }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const tooltipStyle = {
    position: 'absolute',
    bottom: '24px',
    left: '16px',
    backgroundColor: '#333',
    color: 'white',
    padding: '5px 10px',
    borderRadius: '12px',
    borderBottomLeftRadius: '0',
    fontSize: '12px',
    maxWidth: '200px',
    width: 'max-content',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    textAlign: 'center',
    opacity: showTooltip ? 0.9 : 0,
    visibility: showTooltip ? 'visible' : 'hidden',
    transition: 'opacity 0.24s ease-in-out, visibility 0.24s ease-in-out',
    zIndex: 1000,
  };

  const containerStyle = {
    position: 'relative',
    display: 'inline-block',
    cursor: 'pointer',
    height: '18px',
  };

  return (
    <div
      style={containerStyle}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <div style={tooltipStyle}>{tooltipText}</div>
      <svg
        fill="#000000"
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        width="18px"
        height="18px"
        viewBox="-41.7 -41.7 500.38 500.38"
        stroke="#000000"
        strokeWidth="0.004"
        transform="rotate(0)"
        opacity="0.8"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0" />
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="#CCCCCC"
          strokeWidth="6.7"
        />
        <g id="SVGRepo_iconCarrier">
          <g>
            <path d="M356.004,61.156c-81.37-81.47-213.377-81.551-294.848-0.182c-81.47,81.371-81.552,213.379-0.181,294.85 c81.369,81.47,213.378,81.551,294.849,0.181C437.293,274.636,437.375,142.626,356.004,61.156z M237.6,340.786 c0,3.217-2.607,5.822-5.822,5.822h-46.576c-3.215,0-5.822-2.605-5.822-5.822V167.885c0-3.217,2.607-5.822,5.822-5.822h46.576 c3.215,0,5.822,2.604,5.822,5.822V340.786z M208.49,137.901c-18.618,0-33.766-15.146-33.766-33.765 c0-18.617,15.147-33.766,33.766-33.766c18.619,0,33.766,15.148,33.766,33.766C242.256,122.755,227.107,137.901,208.49,137.901z" />
          </g>
        </g>
      </svg>
    </div>
  );
};

export default InfoTooltipIcon;
